import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 18h-3.5a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4","key":"svg-0"}],["path",{"d":"M9 18v3h3","key":"svg-1"}],["path",{"d":"M9 6v-3h6v3","key":"svg-2"}],["path",{"d":"M16 22l5 -5","key":"svg-3"}],["path",{"d":"M21 21.5v-4.5h-4.5","key":"svg-4"}]]

const IconDeviceWatchShare = createReactComponent('outline', 'device-watch-share', 'DeviceWatchShare', __iconNode);

export default IconDeviceWatchShare;